<section class="container-fluid clearfix pb-2">
  <div class="row">
    <div class="col-12 p-0" *ngIf="data.filters">
      <app-mapa-reto-verde
        [sedes]="data"
        [catalogo]="popups"
        ></app-mapa-reto-verde>
    </div>
  </div>
</section>
